import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 24,
	viewBox: "0 0 40 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M25.261 2.96014H14.7071V21.0401H25.261V2.96014Z",
			fill: "#FF5A00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4097 12C15.4097 8.32669 17.2207 5.06647 19.9997 2.96C17.9545 1.4267 15.3746 0.5 12.5605 0.5C5.89401 0.5 0.5 5.64335 0.5 12C0.5 18.3566 5.89401 23.5 12.5605 23.5C15.3746 23.5 17.9545 22.5732 19.9997 21.0399C17.2169 18.9632 15.4097 15.6733 15.4097 12Z",
			fill: "#EB001B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.5001 12C39.5001 18.3566 34.106 23.5 27.4397 23.5C24.6255 23.5 22.0456 22.5733 20.0004 21.04C22.8145 18.9298 24.5904 15.6733 24.5904 12C24.5904 8.32669 22.7794 5.06647 20.0004 2.96001C22.0417 1.4267 24.6216 0.5 27.4357 0.5C34.106 0.5 39.5001 5.67687 39.5001 12Z",
			fill: "#F79E1B"
		})
	]
});
export default SvgMastercard;
